









































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import BlogTagList from '~/components/Blog/BlogTagList.vue'
import DateTime from '~/components/Other/Format/DateTime.vue'

@Component({
  name: 'BlogItem',
  components: { DateTime, BlogTagList }
})
export default class extends Vue {
  @Prop() item
  @Prop() type

  // TODO: Following fix: replace [images] in blog_posts.json with “/images/”
  get imgSrc() {
    return this.item.Image.startsWith('images')
      ? `/${this.item.Image}`
      : `/com_rsblog/assets/images/blog/${this.item.Image}`
  }
}
